import { gitnum } from 'gitnum';
import React from 'react';
import { Navbar } from 'react-bootstrap';
import './footer.css';

const Footer = () => (
  <footer>
    <Navbar className="justify-content-between pb-1" bg="dark" variant="dark" fixed="bottom">
      <Navbar.Text className="footer-left">
        <a href="https://rebattery.gr/" target="_blank" rel="noopener noreferrer">
          Re-Battery
        </a>{' '}
        {'\u00A92025'}
      </Navbar.Text>
      <Navbar.Text className="footer-right">
        <em>created by</em>&nbsp;
        <a href="http://www.motion.gr" target="_blank" rel="noopener noreferrer">
          Motion Hellas Ltd.
        </a>
        &nbsp;
        {/* Version */}
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.location.reload(); // like Ctrl + F5
            alert(
              'Έκδοση: ' +
                gitnum.describe +
                '\nBuild:  ' +
                gitnum.git +
                '\nBranch: ' +
                gitnum.branch +
                '\nCommit: ' +
                gitnum.commit +
                '\nDate:   ' +
                gitnum.date,
            );
          }}
        >
          &nbsp; <em>Έκδοση</em> <span style={{ color: 'white' }}>{gitnum.version}</span>
        </span>
      </Navbar.Text>
    </Navbar>
  </footer>
);

export default Footer;
